import { images } from "@/config/site";
import { Reveal } from "@/components/Reveal";

export function PageHero({ eyebrow, title, intro, image, children }) {
  return (
    <section className="relative overflow-hidden bg-ink" data-testid="page-hero">
      {image && (
        <>
          <img
            src={images[image].url}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 h-full w-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/85 to-slate-950/40" aria-hidden="true" />
        </>
      )}
      <div
        className="pointer-events-none absolute -left-32 top-0 h-[360px] w-[360px] rounded-full opacity-20 blur-3xl"
        style={{ background: "radial-gradient(circle, #F97316 0%, transparent 65%)" }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 md:py-28 lg:px-8">
        <Reveal>
          {eyebrow && (
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-ember">{eyebrow}</p>
          )}
          <h1 className="mt-4 max-w-3xl font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-slate-50 sm:text-5xl lg:text-6xl">
            {title}
          </h1>
          {intro && <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">{intro}</p>}
          {children}
        </Reveal>
      </div>
    </section>
  );
}
